import { SERVICE_ROUTES } from "../../constants/serviceRoutes";

const homeCrumb = { label: "Home", to: "/" };
const servicesCrumb = { label: "Services", to: SERVICE_ROUTES.index };
const hrServicesCrumb = { label: "HR Services", to: SERVICE_ROUTES.hrIndex };
const payrollServicesCrumb = {
  label: "Payroll Services",
  to: SERVICE_ROUTES.payrollIndex,
};
const healthServicesCrumb = {
  label: "Health Services",
  to: SERVICE_ROUTES.healthIndex,
};

export const buildServiceBreadcrumbs = (section, currentLabel) => {
  const trail = [homeCrumb, servicesCrumb];

  if (section === "hr") {
    trail.push(hrServicesCrumb);
  } else if (section === "payroll") {
    trail.push(payrollServicesCrumb);
  } else if (section === "health") {
    trail.push(healthServicesCrumb);
  }

  if (currentLabel) {
    trail.push({ label: currentLabel });
  }

  return trail;
};

export const getServiceIndexBreadcrumbs = (pathname) => {
  if (pathname === SERVICE_ROUTES.hrIndex) {
    return buildServiceBreadcrumbs("hr");
  }

  if (pathname === SERVICE_ROUTES.payrollIndex) {
    return buildServiceBreadcrumbs("payroll");
  }

  if (pathname === SERVICE_ROUTES.healthIndex) {
    return buildServiceBreadcrumbs("health");
  }

  return buildServiceBreadcrumbs();
};
